<template>
	<div :id="baseId" class="footer-panel">
		<div class="footer-panel-block">
			<div class="l-column">
				<a class="social-icon" v-for="(social, index) in socialsList" :href="social.url" target="_blank" :key="`social-${index}`">
					<img :key="index" :src="social.icon" :alt="social.name" />
				</a>
				<img src="/images/home/v6/stan_logo_footer.svg" alt="Stan" class="stan-icon" />
			</div>
			<div class="r-column">
				<a class="footer-links" @click.prevent="$emitter.emit('sign.in', 'footer')" target="_blank" href="https://admin.stan.store/register"
					>Sign In</a
				>
				<a class="footer-links" :href="link.href" target="_blank" v-for="(link, i) in links" :key="`link-${i}`">{{ link.name }}</a>
			</div>
		</div>
	</div>
</template>
<script>
	import { defineComponent, computed, getCurrentInstance, ref } from 'vue'

	const socials = [
		{
			name: 'Linkedin',
			icon: '/images/home/v4/icons/linkedin.svg',
			url: 'https://www.linkedin.com/company/stanwithme',
		},
		{
			name: 'TikTok',
			icon: '/images/home/v4/icons/tiktok.svg',
			url: 'https://www.tiktok.com/@stanforcreators',
		},
		{
			name: 'Instagram',
			icon: '/images/home/v4/icons/instagram-logo.svg',
			url: 'https://www.instagram.com/stanforcreators',
		},
		{
			name: 'Twitter',
			icon: '/images/home/v4/icons/twitter.svg',
			url: 'https://twitter.com/stanforcreators',
		},
		{
			name: 'Youtube',
			icon: '/images/home/v4/icons/youtube.svg',
			url: 'https://www.youtube.com/channel/UCQ1wox_PP5Lds__fQdy6NvQ',
		},
	]

	const links = [
		{ name: 'Blog', href: 'https://stan.store/blog' },
		{
			name: 'Referral Program',
			href: 'https://help.stan.store/article/89-referral-program-overview',
		},
		{ name: 'Ambassador Program', href: 'https://www.stan.store/partnerships' },
		{ name: 'Jobs', href: 'https://jobs.stan.store/' },
		{ name: 'Help', href: 'https://help.stan.store/' },
		{ name: 'Privacy Policy', href: 'https://assets.stanwith.me/legal/privacy-policy.pdf' },
		{ name: 'Terms and Conditions', href: 'https://assets.stanwith.me/legal/terms-of-service.pdf' },
	]

	export default defineComponent({
		name: 'LandingV6Footer',
		props: {
			id: {
				type: [String, Number],
			},
			activeComponent: { type: Boolean },
		},
		setup(props) {
			const socialsList = computed(() => {
				return socials.slice().reverse()
			})

			return {
				baseId: `${props.id}`,
				addonId: `${props.id}-add-on`,
				socialsList,
				links,
			}
		},
	})
</script>

<style lang="scss" scoped>
	@import '@/assets/styles/helpers-v6.scss';

	.footer-panel {
		display: flex;
		flex-direction: column;
		background-color: var(--stan-footer-panel-section-background, #ffffff);
		width: 100vw;
		margin: auto;
		&,
		a {
			color: var(--primary-color);
		}
		a:hover {
			color: #090e2a;
		}

		&-block {
			display: grid !important;
			grid-template-columns: 50% auto;
			grid-gap: 4.4%;
			padding: 56px 4.4%;

			.l-column {
				position: relative;
				padding-top: 10px;
				display: flex;
				justify-content: flex-start;
				align-items: flex-start;

				.social-icon {
					flex: 1 0 0;
					max-width: 70px;

					img {
						min-width: 40px;
					}
				}
				.stan-icon {
					position: absolute;
					bottom: 13px;
					left: -1px;
				}
			}
			.r-column {
				padding-left: 28.5%;
				a.footer-links {
					display: block;
					font-family: Plus Jakarta Sans, sans-serif;
					font-style: normal;
					font-weight: 400;
					font-size: 16px;
					line-height: 200%;
					letter-spacing: 0.005em;
				}
			}

			@media (max-width: $primary-mobile-breakpoint-px) {
				& {
					grid-template-columns: 1fr;
					grid-gap: 0;
					padding: 4px 10px 4px 20px;
					.l-column {
						.social-icon {
							flex: 1 0 0;
							max-width: 70px;
							img {
								min-width: 47.5px;
							}
						}
						.stan-icon {
							bottom: -385px;
							left: 8px;
						}
					}
					.r-column {
						padding-top: 29px;
						padding-left: 5px;
					}
				}
			}
		}

		@media (max-width: $primary-mobile-breakpoint-px) {
			padding-top: 23px;
			padding-bottom: 102px;
			margin: unset;
		}
	}
</style>
